module.exports = {"id":"%{id}","title":"%{title}","description":"%{description}","state":"%{state}","type":"tax","mandatory":true,"displayCondition":{"type":"true"},"condition":{"type":"and","conditions":[{"type":"true"},{"type":"or","conditions":"%{deliveryTypeConditions}"}]},"operator":{"type":"multiply","numerators":[{"type":"sum_prices","items":"%{applyTo}","charges":"%{applyToCharges}"},{"type":"value","value":"%{percent}"}],"denominators":[{"type":"value","value":100000}]}}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/ChargeV2.template.tax.json
// module id = 961
// module chunks = 0